<div class="loader-overlay" *ngIf="loading$ | async">
    <mat-spinner></mat-spinner>
</div>

  